/**
 * Aura On Board — New Take Over Client preset
 *   (my_preset / sg / aura / onboard) — 자체완결 모듈, 자체등록.
 *
 * 매칭 = task code CAU006 (Aura 접두어 CAU).
 *   priority 55 (agm 55 / agm-multi 56 / agm-sole-corp 57 등과 코드 전용 매칭이라 충돌 없음).
 * 배선: sg/aura/index.ts 가 이 모듈을 import 하면 로드 시 자동 등록.
 *
 * 문서: DR(Change of Director / Secretary / Registered Office) · Form 45(이사별) ·
 *   Form 45B(비서별) · Corporate Secretarial Service Agreement bundle.
 */
import { registerPanel } from '@/features/startTask/preset_task/shared/preset/panels/panelRegistry';
import { registerChatFlow } from '@/features/startTask/preset_task/shared/preset/chatflows/chatFlowRegistry';
import type { PreSetSelection } from '@/features/startTask/preset_task/shared/preset/types/preset.types';
import PreSetAuraOnBoardPanel from './components/PreSetAuraOnBoardPanel.vue';
import { auraOnBoardFlow } from './chatflows/auraOnBoardFlow';

export { default as PreSetAuraOnBoardPanel } from './components/PreSetAuraOnBoardPanel.vue';
export { auraOnBoardFlow } from './chatflows/auraOnBoardFlow';

/** 공통코드 — Aura On Board (New Take Over Client) 은 CAU006 로 발급됨. */
export const AURA_ONBOARD_TASK_CODES: string[] = ['CAU006'];

export function matchesAuraOnBoard(sel: PreSetSelection): boolean {
  const code = (sel.task.TASK_CODE || '').toUpperCase();
  return AURA_ONBOARD_TASK_CODES.map((c) => c.toUpperCase()).includes(code);
}

export function registerAuraOnBoardPreset(): void {
  registerChatFlow(auraOnBoardFlow);
  registerPanel({
    id: 'aura-onboard',
    priority: 55,
    match: (sel) => matchesAuraOnBoard(sel),
    component: PreSetAuraOnBoardPanel,
    meta: { docType: 'SG_ONBOARD_PRE', studio: true },
  });
}

registerAuraOnBoardPreset();
